import { useState, useEffect } from "react";

// Use to find if current media screen verifies query or not
//usage: const small = useMedia("(max-width: 400px)");

export default function useMedia(query) {
  let [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    let media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    let listener = () => setMatches(media.matches);
    media.addListener(listener);
    return () => media.removeListener(listener);
  }, [query, matches]);
  return matches;
}
